import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { spacing } from '@conserveit/blocks'
import { MsgAlert } from '../../../components'
import SiteGroupForm from './SiteGroupForm'
import ProjectGroupForm from './ProjectGroupForm'
import ResponsibleGroupForm from './ResponsibleGroupForm'
import GroupTypeForm from './GroupTypeForm'

const Container = styled.div`
  width: 600px;
  min-height: 230px;
  padding: ${spacing.loose};
`

const GroupForm = ({
  groupTypeOptions,
  projectOptions,
  formData,
  onChange,
  error,
  editing
}) => (
  <Container>
    <MsgAlert type="error" message={error} />

    <form>
      <GroupTypeForm
        onChange={onChange}
        groupType={formData.group_type}
        editing={editing}
        groupTypeOptions={groupTypeOptions}
        formData={formData}
      />

      {(formData.group_type === 'project') && (
        <ProjectGroupForm
          groupKey={formData.group_key}
          groupName={formData.group_name}
          onChange={onChange}
        />
      )}

      {(formData.group_type === 'site') && (
        <SiteGroupForm
          project={formData.project}
          groupName={formData.group_name}
          onChange={onChange}
          projectOptions={projectOptions}
        />
      )}

      {(formData.group_type === 'group') && (
        <ResponsibleGroupForm
          groupName={formData.group_name}
          onChange={onChange}
        />
      )}
    </form>
  </Container>
)

GroupForm.propTypes = {
  groupTypeOptions: PropTypes.object,
  projectOptions: PropTypes.object,
  formData: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  editing: PropTypes.bool.isRequired
}

GroupForm.defaultProps = {
  groupTypeOptions: {},
  projectOptions: {}
}

export default GroupForm
